import { Middleware } from "../Middleware";
import { MiddlewareInterface } from "../MiddlewareInterface";
import Constants from "../../Action/Constants";

class PaymentsWillMount extends Middleware implements MiddlewareInterface {

  public component: any;

  constructor() {
    super();
  }

  public process(): void {
    this.component.setState({
      ...this.component.state,
      ...this.component.props.app.dashboardPaymentsFilterCheckBoxState
    }, () => {
      this.component.props.dispatch({
        type: Constants.SAVED_DATA_BEFORE_REDIRECTING_CLEAR
      });
      
      const selectedFilterBankAccount = "all";
  
      this.component.paginatorPath = `Dashboard_Payments_${selectedFilterBankAccount}`;
  
      this.component.setState({
        filter: "unused",
        agencyBankAccountId: "all",
        filterValue: "",
        isPaymentUlinkPopupOpen: false,
        isPaymentRemovePopupOpen: false,
        isSaving: false,
        paymentDelete: null,
        isPaymentCheckToSettle: false,
        isPaymentUnSettlePopupOpen: false,
        unSettlePayment: null,
        dateFilter: undefined,
        pontoConnectionDialogFromParams: this.component.props?.location?.query?.result ? true : false,
        pontoConnectionDialogMessageFromParams: this.component.props?.location?.query?.result || ""
      }, () => {
  
        this.component.fetchFirstUnusedPayments(() => {
          window.scrollTo({
            top: this.component.props.app?.dashboardPaymentsListPosition
          });
        });
      });
    })
  }
}

export default new PaymentsWillMount();
